export const COMPONENT_TYPE = {
    LAMP: "lamp", // 路灯
    TREE: "tree", // 树
    COMPASS: "compass", // 指北针
}